export { default } from './LazyGetLeadBannerSnackBar';
